/*
 * App entry — 2026 redesign.
 *
 * Marketing-only site. No user accounts, no admin panel, no crypto/wallet
 * flow — just the homepage, the researchers landing, the contact-sales
 * form, the docs pages, and the privacy/terms statics. Removed: admin/,
 * consumer/, auth flow (sign-in/up/password/email-verification), the NFT
 * detail page, and the WalletDoc / HowWePay crypto docs.
 * See git log for the cleanup commits.
 */

import { useCallback, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";

import { useSelector } from "react-redux";

import { Home } from "pages/Home";
import Researchers from "pages/Researchers";
import { UseCases } from "pages/UseCases";
import { ContactSales } from "pages/ContactSales";
import { DataPrivacyTerms } from "pages/DataPrivacyTerms";
import { WhatData } from "pages/Docs/WhatData";
import { HowWeCollect } from "pages/Docs/HowWeCollect";
import { EULA } from "pages/Docs/EULA";
import { MobileTerms } from "pages/Docs/MobileTerms";

import { CustomSnackbar } from "components/CustomSnackbar";
import { CustomBackdrop } from "components/CustomBackdrop";
import { getDataStats, loadAreas } from "utils/sensors";

export default function App() {
  const { areas } = useSelector((state) => state.sensor);
  const { pathname } = useLocation();

  // Reset page scroll on route change.
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // One-time hydrate of public sensor/area data used by the DataExplorer
  // and GlobalNetwork map sections.
  const loadingAsyncData = useCallback(async () => {
    if (areas.length === 0) {
      await loadAreas();
      await getDataStats();
    }
  }, [areas.length]);

  useEffect(() => {
    loadingAsyncData();
  }, [loadingAsyncData]);

  return (
    <ThemeProvider theme={theme}>
      <CustomSnackbar />
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/researchers" element={<Researchers />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/contact-sales" element={<ContactSales />} />

        <Route path="/dataPrivacy" element={<DataPrivacyTerms />} />
        <Route path="/docs/what" element={<WhatData />} />
        <Route path="/docs/how" element={<HowWeCollect />} />
        <Route path="/docs/EULA" element={<EULA />} />
        <Route path="/docs/appTerms" element={<MobileTerms />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <CustomBackdrop />
    </ThemeProvider>
  );
}
